import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Banner } from 'src/app/model/shared/banner';
import { SharedDataService } from 'src/app/service/shared-data.service';

@Component({
  selector: 'app-iag-portal-page',
  templateUrl: './iag-portal-page.component.html',
  styleUrls: ['./iag-portal-page.component.scss']
})
export class IagPortalPageComponent implements OnInit {
  pageTitle = '';
  banner: Banner = {} as Banner;

  constructor(private activatedRoute: ActivatedRoute, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => (this.pageTitle = params['pageTitle']));

    this.sharedDataService.sharedData.subscribe((banner) => {
      this.banner = banner;
    });
  }
}
